/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import { helpContent } from 'components/BiteDB/common/HelpContent';
import { useSnackbar } from 'notistack';
import { Link, Redirect } from 'react-router-dom';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import Dashboard from 'components/BiteDB/Dashboard';
import PeopleAndCompany from 'components/BiteDB/PeopleAndCompany';
import Databases from 'components/BiteDB/Databases';
import Tariffs from 'components/BiteDB/Tariffs';
import DBModuleHeaderLayout from 'components/Common/Layouts/DBModuleHeaderLayout';
import BulkLinkEntitiesModal from 'components/BiteDB/Modal/BulkLinkEntitiesModal';
import BiteDBAPI from '../../api/BiteDBAPI';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Modal,
  Tooltip,
} from '@mui/material';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import { useGetDatabasesByGroupId } from '../../api/bitedb/database/database.hooks';
import PriceCheckOutlinedIcon from '@mui/icons-material/PriceCheckOutlined';
import { useBulkUploadEvents } from 'hooks/useSocketIO';

const BiteDB: React.FC = (props: any) => {
  const { cur_user } = useContext(GlobalContext);
  const { enqueueSnackbar } = useSnackbar();
  const [autoTab, setAutoTab] = useState<string>('Dashboard');
  const [userHasMonitor, setUserHasMonitor] = useState(false);
  const [isScroll, setIsScroll] = useState(false);
  const [isCheckingSubscription, setIsCheckingSubscription] = useState(true);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [originalNrEntities, setOriginalNrEntities] = useState<number>(0);
  const [originalNrTariffs, setOriginalNrTariffs] = useState<number>(0);
  const [processingDatabases, setProcessingDatabases] = useState<Set<string>>(
    new Set(),
  );
  const pendingLinkEntitiesDatabaseIdsRef = useRef<Set<string>>(new Set());
  const [linkEntitiesDatabaseId, setLinkEntitiesDatabaseId] = useState<
    string | null
  >(null);
  const [showLinkEntitiesPrompt, setShowLinkEntitiesPrompt] = useState(false);
  const [showLinkEntitiesModal, setShowLinkEntitiesModal] = useState(false);

  // Listen for bulk upload events via Socket.IO for global notifications
  useBulkUploadEvents(undefined, {
    onComplete: (result) => {
      if (result.databaseId) {
        const completedDatabaseId = result.databaseId.toString();
        setProcessingDatabases((prev) => {
          const updated = new Set(prev);
          updated.delete(completedDatabaseId);
          return updated;
        });
        if (
          pendingLinkEntitiesDatabaseIdsRef.current.has(completedDatabaseId)
        ) {
          pendingLinkEntitiesDatabaseIdsRef.current.delete(completedDatabaseId);
          setLinkEntitiesDatabaseId(completedDatabaseId);
          setShowLinkEntitiesPrompt(true);
        }
        refetchDbs();
        enqueueSnackbar(
          `Entities uploaded successfully! ${
            result.duplicatesRemoved
              ? `${result.duplicatesRemoved} duplicates were removed.`
              : ''
          }`,
          { variant: 'success' },
        );
      }
    },
    onFailed: (result) => {
      console.error('[BiteDB] Bulk upload failed:', result);
      if (result.databaseId) {
        const failedDatabaseId = result.databaseId.toString();
        setProcessingDatabases((prev) => {
          const updated = new Set(prev);
          updated.delete(failedDatabaseId);
          return updated;
        });
        pendingLinkEntitiesDatabaseIdsRef.current.delete(failedDatabaseId);
        enqueueSnackbar(
          result.error || 'Entity upload failed. Please check the database.',
          { variant: 'error' },
        );
      }
    },
  });

  const handleDatabaseCreated = (databaseId: string) => {
    setProcessingDatabases((prev) => new Set(prev).add(databaseId));
  };

  const handleDatabaseUploadFailed = (databaseId: string) => {
    setProcessingDatabases((prev) => {
      const updated = new Set(prev);
      updated.delete(databaseId);
      return updated;
    });
    pendingLinkEntitiesDatabaseIdsRef.current.delete(databaseId);
  };

  const handleOfferLinkEntities = (databaseId: string) => {
    pendingLinkEntitiesDatabaseIdsRef.current.add(databaseId);
  };

  const handleConfirmLinkEntities = () => {
    setShowLinkEntitiesPrompt(false);
    setShowLinkEntitiesModal(true);
  };

  const handleDismissLinkEntities = () => {
    setShowLinkEntitiesPrompt(false);
    setLinkEntitiesDatabaseId(null);
  };

  const handleLinkEntitiesClose = () => {
    setShowLinkEntitiesModal(false);
    setLinkEntitiesDatabaseId(null);
    refetchDbs();
  };

  /**
   * Get Databases by the Group ID with - search if appl.
   */
  const {
    data: dbs,
    isLoading: dbsLoading,
    error: dbsError,
    refetch: refetchDbs,
  } = useGetDatabasesByGroupId(cur_user.selected_team.id, searchTerm);

  // Use filtered data for display
  const entityDatabases = Array.isArray(dbs)
    ? dbs.filter((db) => db.type === 'people & companies')
    : [];

  const tariffDatabases = Array.isArray(dbs)
    ? dbs.filter((db) => db.type === 'tariffs')
    : [];
  // Use unfiltered data for total counts (won't change with search)
  const allEntityDatabases = Array.isArray(dbs)
    ? dbs.filter((db) => db.type === 'people & companies')
    : [];
  const allTariffDatabases = Array.isArray(dbs)
    ? dbs.filter((db) => db.type === 'tariffs')
    : [];
  const nrEntitiesCount = allEntityDatabases?.length;
  const nrTariffsCount = allTariffDatabases?.length;

  const total_number_of_entities = entityDatabases.reduce(
    (acc, db) => acc + (db?.nr_people_and_companies || 0),
    0,
  );
  const total_number_of_tariffs = tariffDatabases.reduce(
    (acc, db) => acc + (db?.nr_tariffs ?? 0),
    0,
  );

  /**
   * Set original nr entities on first render
   */
  useEffect(() => {
    if (Array.isArray(dbs) && originalNrEntities === 0) {
      setOriginalNrEntities(
        dbs.filter((db) => db.type === 'people & companies').length,
      );
      setOriginalNrTariffs(dbs.filter((db) => db.type === 'tariffs').length);
    }
  }, [dbs, originalNrEntities]);

  /**
   * Handle dbs error messages
   */
  useEffect(() => {
    if (dbsError) {
      enqueueSnackbar(`Error fetching databases: ${dbsError.message}`, {
        variant: 'error',
      });
    }
  }, [dbsError, enqueueSnackbar]);

  /**
   * Set auto tab on first render
   */
  useEffect(() => {
    if (props.location.state) {
      const { linkTab } = props.location.state;
      setAutoTab(linkTab);
    }
  }, []);
  const handleTabSwitch = (newTab: string) => {
    switch (newTab) {
      case 'Dashboard':
        setAutoTab('Dashboard');
        window.sessionStorage.setItem('autoTab', 'Dashboard');
        break;
      case 'Databases':
        setAutoTab('Databases');
        window.sessionStorage.setItem('autoTab', 'Databases');
        break;
      case 'People & Companies':
        setAutoTab('People & Companies');
        window.sessionStorage.setItem('autoTab', 'People & Companies');
        break;
      case 'Tariffs':
        setAutoTab('Tariffs');
        window.sessionStorage.setItem('autoTab', 'Tariffs');
        break;
      default:
        setAutoTab('Dashboard');
    }
  };
  const requiredTiers = [
    'business',
    'enterprise',
    'database',
    'tariff database',
  ];

  const checkSubscription = async () => {
    if (cur_user.quickcodeOnly) {
      setUserHasMonitor(true);
      setIsCheckingSubscription(false);
      return;
    }
    try {
      // Check enterprise tier first
      if (
        requiredTiers.some((role) =>
          cur_user.selected_team?.attributes?.tier.includes(role),
        )
      ) {
        setUserHasMonitor(true);
        setIsCheckingSubscription(false);
        return;
      }
    } finally {
      // Always set checking to false when done
      setIsCheckingSubscription(false);
    }
  };

  const runScreening = async (databaseId: string) => {
    const selected_team_id = cur_user?.selected_team?.id;
    if (!selected_team_id) {
      enqueueSnackbar('Please select a team', { variant: 'error' });
      return;
    }
    const response = await BiteDBAPI.runDatabaseScreening(databaseId);
    if (response?.success) {
      enqueueSnackbar('Successfully started a new screening', {
        variant: 'success',
      });
    }
  };

  // Initial data fetch
  useEffect(() => {
    checkSubscription();
  }, []);

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  return (
    <DBModuleHeaderLayout
      title='BITE DB'
      helpContent={helpContent}
      handleRefresh={() => {
        refetchDbs();
      }}
      tabState={autoTab}
      onDatabaseCreated={handleDatabaseCreated}
      onDatabaseUploadFailed={handleDatabaseUploadFailed}
      onOfferLinkEntities={handleOfferLinkEntities}
    >
      <div>
        <div className='screening-tabs-container'>
          <div
            className='screening-tabs-inner'
            style={{ justifyContent: 'space-between', width: '100%' }}
          >
            <div style={{ display: 'flex', gap: '8px', flex: 1 }}>
              <div
                className={`screening-tab-btn${
                  autoTab === 'Dashboard' ? '-selected' : ''
                }`}
                onClick={() => handleTabSwitch('Dashboard')}
              >
                <div
                  className={`screening-tab-btn-text${
                    autoTab === 'Dashboard' ? '-selected' : ''
                  }`}
                >
                  {autoTab === 'Dashboard' ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 18 18'
                      fill='none'
                      style={{ marginRight: '5px' }}
                    >
                      <path
                        d='M2.25 7.92385C2.25 7.49308 2.25 7.2777 2.30552 7.07935C2.3547 6.90365 2.43552 6.73839 2.54402 6.5917C2.6665 6.4261 2.83652 6.29387 3.17654 6.0294L8.26327 2.07306C8.52677 1.86812 8.65851 1.76565 8.80399 1.72626C8.93235 1.69151 9.06765 1.69151 9.19601 1.72626C9.34149 1.76565 9.47324 1.86812 9.73673 2.07306L14.8235 6.02941C15.1635 6.29387 15.3335 6.4261 15.456 6.5917C15.5645 6.73839 15.6453 6.90365 15.6945 7.07935C15.75 7.2777 15.75 7.49308 15.75 7.92385V13.35C15.75 14.1901 15.75 14.6102 15.5865 14.931C15.4427 15.2133 15.2132 15.4427 14.931 15.5866C14.6101 15.75 14.1901 15.75 13.35 15.75H4.65C3.80992 15.75 3.38988 15.75 3.06901 15.5866C2.78677 15.4427 2.5573 15.2133 2.41349 14.931C2.25 14.6102 2.25 14.1901 2.25 13.35V7.92385Z'
                        stroke='#4895EF'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='18'
                      height='18'
                      viewBox='0 0 18 18'
                      fill='none'
                      style={{ marginRight: '5px' }}
                    >
                      <path
                        d='M2.25 7.92385C2.25 7.49308 2.25 7.2777 2.30552 7.07935C2.3547 6.90365 2.43552 6.73839 2.54402 6.5917C2.6665 6.4261 2.83652 6.29387 3.17654 6.0294L8.26327 2.07306C8.52677 1.86812 8.65851 1.76565 8.80399 1.72626C8.93235 1.69151 9.06765 1.69151 9.19601 1.72626C9.34149 1.76565 9.47324 1.86812 9.73673 2.07306L14.8235 6.02941C15.1635 6.29387 15.3335 6.4261 15.456 6.5917C15.5645 6.73839 15.6453 6.90365 15.6945 7.07935C15.75 7.2777 15.75 7.49308 15.75 7.92385V13.35C15.75 14.1901 15.75 14.6102 15.5865 14.931C15.4427 15.2133 15.2132 15.4427 14.931 15.5866C14.6101 15.75 14.1901 15.75 13.35 15.75H4.65C3.80992 15.75 3.38988 15.75 3.06901 15.5866C2.78677 15.4427 2.5573 15.2133 2.41349 14.931C2.25 14.6102 2.25 14.1901 2.25 13.35V7.92385Z'
                        stroke='var(--card-text)'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  )}
                  Dashboard
                </div>
              </div>
              {!cur_user.selected_team?.attributes?.tier?.includes(
                'tariff database',
              ) && (
                <div
                  className={`screening-tab-btn${
                    autoTab === 'People & Companies' ? '-selected' : ''
                  }`}
                  onClick={() => handleTabSwitch('People & Companies')}
                >
                  <div
                    className={`screening-tab-btn-text${
                      autoTab === 'People & Companies' ? '-selected' : ''
                    }`}
                  >
                    {autoTab === 'People & Companies' ? (
                      <PeopleAltOutlinedIcon
                        sx={{ fontSize: 18, color: '#4895EF', mr: '5px' }}
                      />
                    ) : (
                      <PeopleAltOutlinedIcon
                        sx={{
                          fontSize: 18,
                          color: 'var(--card-text)',
                          mr: '5px',
                        }}
                      />
                    )}
                    Entity Database
                  </div>
                </div>
              )}
              {!cur_user.quickcodeOnly && (
                <div
                  className={`screening-tab-btn${
                    autoTab === 'Tariffs' ? '-selected' : ''
                  }`}
                  onClick={() => handleTabSwitch('Tariffs')}
                >
                  <div
                    className={`screening-tab-btn-text${
                      autoTab === 'Tariffs' ? '-selected' : ''
                    }`}
                  >
                    {autoTab === 'Tariffs' ? (
                      <PriceCheckOutlinedIcon
                        sx={{ fontSize: 18, color: '#4895EF', mr: '5px' }}
                      />
                    ) : (
                      <PriceCheckOutlinedIcon
                        sx={{ fontSize: 18, color: '', mr: '5px' }}
                      />
                    )}
                    Tariff Database
                  </div>
                </div>
              )}
            </div>
            <div className='module-header-title-conts'>
              <Tooltip
                title={'Screening History'}
                placement='bottom-start'
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      display: 'flex',
                      padding: 'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      alignSelf: 'stretch',
                      borderRadius: 'var(--radius-md, 8px)',
                      background: 'var(--Background-200, var(--bg-colors))',
                      color: 'var(--text-prim25)',
                      maxWidth: '700px',
                      '& .MuiTooltip-arrow': {
                        color: 'var(--Background-200, var(--bg-colors))',
                      },
                    },
                  },
                }}
              >
                <Link
                  to={{
                    pathname: '/screening-setting',
                    state: { linkTab: 'Run Screening' },
                  }}
                >
                  <div
                    className='audit-btn-star'
                    onClick={() => handleTabSwitch('Screening History')}
                  >
                    <NotificationsActiveOutlinedIcon
                      sx={{
                        fontSize: 20,
                        color: 'var(--card-text)',
                      }}
                    />
                  </div>
                </Link>
              </Tooltip>
            </div>
          </div>
        </div>
        <>
          {autoTab === 'Dashboard' && (
            <Dashboard
              setAutoTab={setAutoTab}
              databases={dbs}
              nrOfTotalItems={nrEntitiesCount}
              peopleCount={nrEntitiesCount}
              tariffCount={nrTariffsCount}
              isLoading={dbsLoading}
              onRefresh={() => {
                refetchDbs();
                // fetchEntities();
              }}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isScroll={isScroll}
              setIsScroll={setIsScroll}
              processingDatabases={processingDatabases}
              onDatabaseCreated={handleDatabaseCreated}
              onDatabaseUploadFailed={handleDatabaseUploadFailed}
              onOfferLinkEntities={handleOfferLinkEntities}
            />
          )}
          {autoTab === 'People & Companies' && (
            <PeopleAndCompany
              databases={entityDatabases}
              nrOfEntities={total_number_of_entities}
              peopleCount={total_number_of_entities}
              isLoading={dbsLoading}
              onRefresh={() => {
                refetchDbs();
              }}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              processingDatabases={processingDatabases}
              onDatabaseCreated={handleDatabaseCreated}
              onDatabaseUploadFailed={handleDatabaseUploadFailed}
              onOfferLinkEntities={handleOfferLinkEntities}
            />
          )}
          {autoTab === 'Tariffs' && (
            <Tariffs
              databases={tariffDatabases}
              isLoading={dbsLoading}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              tariffCount={total_number_of_tariffs}
              processingDatabases={processingDatabases}
              onDatabaseCreated={handleDatabaseCreated}
              onDatabaseUploadFailed={handleDatabaseUploadFailed}
              onOfferLinkEntities={handleOfferLinkEntities}
            />
          )}
          {autoTab === 'Databases' && (
            <Databases
              databases={dbs || []}
              isLoading={dbsLoading}
              runScreeningDatabase={runScreening}
              onRefresh={() => {
                refetchDbs();
              }}
            />
          )}
        </>
      </div>
      <Dialog
        className='dialog_box'
        open={showLinkEntitiesPrompt}
        onClose={handleDismissLinkEntities}
        maxWidth='sm'
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: 'var(--bg-colors)',
            borderRadius: '0.5rem',
            overflowY: 'visible',
          },
        }}
      >
        <DialogTitle className='modal-header-content modal-title'>
          Define Entity Relationships
          <div
            className='audit-add-modal-head-cont-icon'
            onClick={handleDismissLinkEntities}
            style={{ cursor: 'pointer' }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
            >
              <path
                d='M18 6L6 18M6 6L18 18'
                stroke='white'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
        </DialogTitle>
        <DialogContent className='dialog-content-base'>
          <div
            className='audit-add-modal-cont-body'
            style={{ paddingTop: '12px', paddingBottom: '12px' }}
          >
            <div className='audit-add-modal-head-cont-supporting'>
              <p style={{ margin: 0 }}>
                Would you like to define relationships between entities in this
                database? You can upload a CSV file to link entities by their
                business registration number (EIN) or person ID.
              </p>
            </div>
          </div>
        </DialogContent>
        <div className='audit-modal-cont-footer'>
          <div className='audit-modal-cont-footer-content'>
            <div
              className='audit-modal-cont-footer-content-btn-cancel'
              onClick={handleDismissLinkEntities}
            >
              <div className='audit-modal-cont-footer-content-btn-text'>
                Later
              </div>
            </div>
            <div
              className='audit-modal-cont-footer-content-btn-upload'
              onClick={handleConfirmLinkEntities}
            >
              <div className='audit-modal-cont-footer-content-btn-text'>
                Yes, Link Entities
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      <Modal open={showLinkEntitiesModal} onClose={handleLinkEntitiesClose}>
        <div style={{ outline: 'none' }}>
          <BulkLinkEntitiesModal
            open={showLinkEntitiesModal}
            onClose={handleLinkEntitiesClose}
            databaseId={linkEntitiesDatabaseId || ''}
            onSuccess={() => refetchDbs()}
          />
        </div>
      </Modal>
    </DBModuleHeaderLayout>
  );
};

export default BiteDB;
